import React from 'react';

function TermeniSiConditii() {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Termeni și Condiții</h1>

      <section style={styles.section}>
        <h2 style={styles.heading}>1. Informații generale</h2>
        <p style={styles.paragraph}>
          Acest document stabilește regulile de utilizare a site-ului LivTuVisitYourCity operat de Staris Company S.R.L. Prin accesarea și utilizarea Site-ului, sunteți de acord să respectați
          acești termeni. Dacă nu sunteți de acord cu oricare dintre acești termeni, vă rugăm să părăsiți Site-ul imediat.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>2. Acceptarea Termenilor</h2>
        <p style={styles.paragraph}>
          Prin accesarea, navigarea și utilizarea Site-ului, confirmați că sunteți de acord cu acești Termeni și Condiții. Compania
          își rezervă dreptul de a modifica termenii în orice moment, iar utilizarea continuă a Site-ului va constitui acceptarea
          acestor modificări.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>3. Descrierea serviciilor</h2>
        <p style={styles.paragraph}>
          LivTuVisitYourCity organizează tururi interactive în orașele din România, oferind experiențe personalizate care includ
          tururi pietonale, tururi regionale și evenimente interactive. Detaliile specifice ale fiecărui tur sunt prezentate pe Site.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>4. Rezervări și plăți</h2>
        <ul style={styles.list}>
          <li>
            <strong>Rezervări:</strong> Toate rezervările pentru tururi se efectuează exclusiv prin intermediul Site-ului.
          </li>
          <li>
            <strong>Prețuri și plăți:</strong> Prețurile afișate sunt în [moneda] și pot include sau exclude taxe. Plata se efectuează prin 
            [metoda de plată] și rezervarea va fi confirmată numai după finalizarea plății.
          </li>
          <li>
            <strong>Confirmare:</strong> O rezervare se confirmă doar după primirea plății și primirea unui e-mail de confirmare din partea Companiei.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>5. Politica de anulare și rambursare</h2>
        <ul style={styles.list}>
          <li>
            <strong>Anulare:</strong> Pentru anularea unei rezervări, vă rugăm să consultați politica de anulare afișată pe Site.
          </li>
          <li>
            <strong>Rambursare:</strong> Rambursările, dacă se acordă, vor fi efectuate conform termenilor specificați și în conformitate cu legislația în vigoare.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>6. Responsabilități și limitări de răspundere</h2>
        <ul style={styles.list}>
          <li>
            <strong>Siguranță:</strong> Participanții sunt obligați să respecte instrucțiunile și regulile de siguranță comunicate de ghid în timpul turului.
          </li>
          <li>
            <strong>Limitare:</strong> Compania nu poate fi considerată responsabilă pentru daune, pierderi sau inconveniente provenite din nerespectarea regulilor de siguranță sau din situații neprevăzute (ex. condiții meteorologice adverse).
          </li>
          <li>
            <strong>Modificări:</strong> Compania își rezervă dreptul de a modifica itinerariul tururilor în funcție de condiții sau pentru îmbunătățirea experienței participanților.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>7. Proprietatea intelectuală</h2>
        <p style={styles.paragraph}>
          Toate materialele, imaginile, textul și elementele de design de pe Site sunt protejate prin drepturi de autor și alte legi de proprietate intelectuală. 
          Nu este permisă reproducerea sau utilizarea fără acordul scris prealabil al Companiei.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>8. Politica de confidențialitate</h2>
        <p style={styles.paragraph}>
          Datele personale colectate prin intermediul Site-ului sunt gestionate conform Politicii de Confidențialitate, care face parte integrantă din acești Termeni și Condiții. 
          Vă rugăm să consultați Politica de Confidențialitate pentru detalii privind modul de colectare și utilizare a datelor.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>9. Modificări ale Termenilor și Condițiilor</h2>
        <p style={styles.paragraph}>
          Compania își rezervă dreptul de a modifica acești Termeni și Condiții în orice moment, fără notificare prealabilă. Toate modificările vor fi publicate pe Site, 
          iar continuarea utilizării Site-ului constituie acceptarea termenilor modificați.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>10. Legislația aplicabilă și jurisdicție</h2>
        <p style={styles.paragraph}>
          Acești Termeni și Condiții sunt guvernați de legislația din România. Orice litigiu va fi soluționat de instanțele competente din România.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>11. Contact</h2>
        <p style={styles.paragraph}>
          Pentru întrebări sau clarificări privind acești Termeni și Condiții, vă puteți adresa la:
        </p>
        <p style={styles.paragraph}>
          Email: robert.stamatie@staristechnology.com <br />
          Telefon: 0735654291
        </p>
      </section>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: "'Georgia', serif",
    lineHeight: '1.6',
    color: '#333',
  },
  title: {
    textAlign: 'center',
    fontSize: '2.5rem',
    marginBottom: '2rem',
  },
  section: {
    marginBottom: '1.5rem',
  },
  heading: {
    fontSize: '1.5rem',
    marginBottom: '0.5rem',
    color: '#2C3E50',
  },
  paragraph: {
    fontSize: '1rem',
    marginBottom: '1rem',
    textAlign: 'justify',
  },
  list: {
    fontSize: '1rem',
    marginLeft: '1.5rem',
    marginBottom: '1rem',
  },
};

export default TermeniSiConditii;
